import React from 'react';
import T from 'prop-types';
import { getYTId } from 'helpers';
import styled from 'styled-components';

const Video = styled.iframe`
  width: 100%;
  height: 53vw;

  @media (min-width: 1280px) {
    height: ${({ height }) => (height ? `${height}vh` : '90vh')};
  }
`;

const VideoSection = ({ src, height }) => {
  const embedSrc = getYTId(src, 'full');
  return (
    <Video
      title={embedSrc}
      type="text/html"
      width="720"
      src={`https://www.youtube.com/embed/${embedSrc}?modestbranding=1&controls=1&fs=0&rel=0&showinfo=0`}
      frameBorder="0"
      allowFullScreen
      height={height}
    />
  );
};

VideoSection.defaultProps = {
  height: null,
  src: '',
};
VideoSection.propTypes = {
  height: T.string,
  src: T.string,
};

export default VideoSection;



// WEBPACK FOOTER //
// ./src/components/modules/VideoSection/VideoSection.js